import { render, staticRenderFns } from "./digital-regulation.vue?vue&type=template&id=59b78bea&scoped=true&"
import script from "./digital-regulation.vue?vue&type=script&lang=js&"
export * from "./digital-regulation.vue?vue&type=script&lang=js&"
import style0 from "./digital-regulation.vue?vue&type=style&index=0&id=59b78bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b78bea",
  null
  
)

export default component.exports